import React from 'react';
import { motion } from 'framer-motion';
import { Brain } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useHealthMetrics } from '../../hooks/useHealthMetrics';

export function StressMonitorButton() {
  const navigate = useNavigate();
  const metrics = useHealthMetrics();

  const handleClick = () => {
    navigate('/calm-monitor');
  };

  const getStressStatus = () => {
    if (metrics.stress.current < 30) return { text: 'Low stress', color: 'text-success' };
    if (metrics.stress.current < 70) return { text: 'Moderate', color: 'text-warning' };
    return { text: 'High stress', color: 'text-destructive' };
  };

  const status = getStressStatus();

  return (
    <motion.button
      onClick={handleClick}
      className="w-full relative group overflow-hidden"
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      {/* Siri-like Glow Container */}
      <div className="relative p-[1px] rounded-lg">
        {/* Animated Border */}
        <div className="absolute inset-0 rounded-lg animate-siri-glow">
          <div className="absolute inset-0 bg-gradient-to-r from-primary/30 via-purple-500/30 to-primary/30 rounded-lg animate-border-flow" />
        </div>

        {/* Inner Content */}
        <div className="relative bg-background rounded-lg p-3">
          {/* Ambient Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-purple-500/5 to-transparent opacity-30" />
          
          {/* Content */}
          <div className="relative flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="relative">
                <Brain className="w-4 h-4 text-primary" />
                <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
              </div>
              <div className="text-left">
                <div className="text-xs font-medium">Calm Monitor</div>
                <div className="text-xs text-muted-foreground hidden sm:block">Current Level</div>
                <div className={`text-xs ${status.color} sm:hidden`}>
                  {status.text}
                </div>
              </div>
            </div>
            <div className="text-xs text-primary sm:block hidden">Monitor Now</div>
          </div>
        </div>
      </div>
    </motion.button>
  );
}